import React from "react";
import { FC } from "react";
import { ComponentProps } from "react";
import { makeStyles } from "@material-ui/core";
import { Theme } from "@material-ui/core";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import withStyles from "@material-ui/core/styles/withStyles";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    userSelect: "none",
  },
}));

const CheckBoxInput: FC<ComponentProps<any>> = ({
  value,
  label,
  checkedColor = "#0676ed",
  defaultColor = "#707070",
  size,
  input: { checked, name, onChange, disabled },
}) => {
  const classes = useStyles();

  const CustomizedCheckbox: any = withStyles({
    root: {
      color: defaultColor,
      "&$checked": {
        color: checkedColor,
      },
    },
    checked: {},
  })((props) => <Checkbox color="default" {...props} />);

  return (
    <FormControlLabel
      className={classes.root}
      label={label}
      control={
        <CustomizedCheckbox
          checked={checked}
          name={name}
          onChange={onChange}
          disabled={disabled}
          size={size}
          value={value}
        />
      }
    />
  );
};
export default CheckBoxInput;
